export default "__VITE_ASSET__daa4ef87__"